<template>
<div>
</div>
</template>

<script>
import i18n from "@/i18n"
export default {
  name: 'Logout',
  created () {
    this.onSubmit()
  },
  methods: {
    onSubmit () {
            this.$http.post('auth/logout')
                .then(request => this.onSubmitSuccessful(request))
                .catch(() => this.onSubmitFailed())
        },
        onSubmitSuccessful (req) {
            if (req.data.code !== '0') {
                this.onSubmitFailed(req)
                return
            }
            this.$store.commit('addtoken', '')
            this.$store.commit('addprofile', '')
            this.$store.commit('addgyms', '')
            this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/login')
        },
        onSubmitFailed () {
            this.$store.commit('addtoken', '')
            this.$store.commit('addprofile', '')
            this.$store.commit('addgyms', '')
            this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/login')
        }
  }
}
</script>
